import React from 'react';
import Base from 'client/components/base';
import StringStore from 'client/stores/strings';
import ButtonRounded from 'client/components/common/button-rounded';
import baseUrl from 'server/routes/base-url';

export default class LearnMore extends Base {
  constructor() {
    super();
  }

  render() {
    let rootClassName = this.css({});

    let wrapperClassName = this.css({ base: 'content' });

    let imageClassName = this.css({
      base: 'learn-more-image',
      compose: ['column'],
    });

    let puffClassName = this.css({
      base: 'learn-more-puff',
      compose: ['column', 'copy-content'],
    });

    let buttonContClassName = this.css({ base: 'button-container' });

    return (
      <section className={rootClassName}>
        <div className={wrapperClassName}>
          <div className={puffClassName}>
            <h1>{StringStore.get('home.learnMore.title')}</h1>
            <p>{StringStore.get('home.learnMore.body')}</p>
            <p>
              <strong>{StringStore.get('home.learnMore.dive')}</strong>
            </p>
            <p>
              <strong>{StringStore.get('home.learnMore.extra')}</strong>
            </p>
            <div className={buttonContClassName}>
              <ButtonRounded variant="" linkTo={baseUrl + 'about'}>
                {StringStore.get('home.learnMore.learnMore')}
              </ButtonRounded>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/landing/learn-more/learn-more.es6